import React from "react";

function AddIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 63 63">
      <circle
        id="Ellipse_782"
        data-name="Ellipse 782"
        cx="31.5"
        cy="31.5"
        r="31.5"
        transform="translate(0)"
        fill="#ededed"
      />
      <text
        id="_"
        data-name="+"
        transform="translate(22 44)"
        fill="#707070"
        fontSize="36"
        fontFamily="ProximaNova-Bold, Proxima Nova"
        fontWeight="700"
        letterSpacing="-0.024em"
      >
        <tspan x="0" y="0">
          +
        </tspan>
      </text>
    </svg>
  );
}

export { AddIcon };
